import { Injectable } from '@angular/core';
import { Http, RequestOptions, Headers } from '@angular/http';
import { JwtHelper } from 'angular2-jwt';
import { Storage } from '@ionic/storage';
import 'rxjs/add/operator/map';
import { API_URL, APP_ID_ONESIGNAL, IS_MULTIPLE_SCHOOL } from './config';
import OneSignal from 'onesignal-cordova-plugin';

@Injectable()
export class AuthService {

  // ipAddress: any = "http://localhost:8080/MadaniSS_API/index.php/api/";
  // ipAddress: any = "http://192.168.1.5:8080/MadaniSS_API/index.php/api/";
  // ipAddress: any = "http://192.168.100.13:8080/MadaniSS_API/index.php/api/";
  // ipAddress: any = "http://madani-tech.com/MadaniSS_API/index.php/api/";
  // ipAddress: any = "http://hidayatullah.app.madani-tech.com/Depok/api/index.php/api/";
  // ipAddress: any = "http://192.168.1.4:8080/MadaniSS_JOINAPI/index.php/api/";
  // ipAddress: any = "http://localhost:8080/MadaniSS_JOINAPI/index.php/api/";
  // ipAddress: any = "http://localhost:8080/MadaniSS/index.php/api/";
  // ipAddress: any = "http://tektikal.co.id/icm.kendari/index.php/api/";
  // ipAddress: any = "http://azzikra.madani-tech.com/index.php/api/";
  ipAddress: any = API_URL;
  jwtHelper: JwtHelper = new JwtHelper();

  dataLogin: any;
  dataAuth: any;
  checkPassword: any;
  changePassword: any;

  constructor(public http: Http, public storage: Storage) {
    
  }

  getDataSekolah() {
    return new Promise(resolve => {
      var url = this.ipAddress + "C_Pilih_Sekolah/all_sekolah";
      this.http.get(url)
        .map(res => res.json())
        .subscribe(data => {
          resolve(data);
        });
    });
  }

  getDataLogin(credential) {
  	if(this.dataLogin) {
  		return Promise.resolve(this.dataLogin);
  	}

  	return new Promise(resolve => {
  		this.http.get("json/data-siswa")
    			.map(res => res.json())
    			.subscribe(data => {
    				var nis = credential.nis;
    				var password = credential.password;

    				var dataFilter = data.data.filter(function(d) {
    					return d.nis === nis && d.password === password;
    				});
    				
    				if(dataFilter.length === 1) {
              var token = credential.nis + credential.password;
              var base64Token = btoa(token);

              this.storage.set('token', base64Token);
              this.storage.set('dataUser', dataFilter[0]);
  	  				this.dataLogin = true;

    				} else {
    					this.dataLogin = false;
    				}
    				
    				resolve(this.dataLogin);
    			}, err => {
    				console.log(err);
    			});
  	});
  }

  getDataLoginJWT(credential) {
    if(this.dataLogin) {
      return Promise.resolve(this.dataLogin);
    }

    return new Promise(resolve => {
      // this.ipAddress = "http://"+ credential.ip +"/MadaniSS_API/index.php/api/";
      var username = credential.nis,
          password = credential.password,
          sekolah = credential.sekolah,
          yayasan = credential.yayasan,
          url = this.ipAddress + "C_Auth/login";

      let headers = new Headers();
      headers.append('Content-Type', 'application/x-www-form-urlencoded');

      let options = new RequestOptions({headers: headers});
      var body = "username="+ username +"&password="+ password + 
                  "&kode_sekolah=" + sekolah + "&yayasan=" + yayasan + "&multiple=" + IS_MULTIPLE_SCHOOL;

      this.http.post(url, body, options)
          .map(res => res.json())
          .subscribe(data => {
            if(data.status === true) {
              // console.log(data.token)
              var decodeToken = this.jwtHelper.decodeToken(data.token);
              // console.log(decodeToken);

              OneSignal.setAppId(APP_ID_ONESIGNAL);
              // OneSignal.deleteTag('idSekolah');
              OneSignal.deleteTag('kodeSekolah');
              OneSignal.deleteTag('yayasan');
              OneSignal.deleteTag('group');
              OneSignal.deleteTag('idUser');
              OneSignal.deleteTag('idKelas');

              // OneSignal.sendTag('idSekolah', credential.sekolah);
              OneSignal.sendTag('kodeSekolah', sekolah);
              OneSignal.sendTag('yayasan', yayasan);
              OneSignal.sendTag('group', decodeToken.group);
              OneSignal.sendTag('idUser', decodeToken.data_user.id_user);

              if(decodeToken.group === "siswa") {
                OneSignal.sendTag('idKelas', decodeToken.data_kelas[0].id_kelas);
                // OneSignal.sendTag('idUser', decodeToken.data_user.id_siswa);
              } else if(decodeToken.group === "guru") {
                OneSignal.sendTag('idKelas', 'many');
                // OneSignal.sendTag('idUser', decodeToken.data_user.id_pegawai);
              } else if(decodeToken.group === "guru") {
                OneSignal.sendTag('idKelas', 'many');
                // OneSignal.sendTag('idUser', decodeToken.data_user.id_pegawai);
              } else if(decodeToken.group === "merchant") {
                OneSignal.sendTag('idKelas', 'many');
                // OneSignal.sendTag('idUser', decodeToken.data_user.id_pegawai);
              } else {
                OneSignal.sendTag('idKelas', 'operator');
              }

              this.storage.set('token', data.token);
              this.storage.set('dataUser', decodeToken.data_user);
              this.storage.set('dataKelas', decodeToken.data_kelas);
              this.storage.set('group', decodeToken.group);
              this.storage.set('decodeToken', decodeToken);
              // this.storage.set('ip', credential.ip);
              // this.storage.set('idSekolah', credential.sekolah);
              this.storage.set('kodeSekolah', sekolah);
              this.storage.set('yayasan', yayasan);

              this.dataLogin = true;
            } else {
              this.dataLogin = false;
            }
            
            resolve(this.dataLogin);
      });
    });
  }

  getCheckAuthJWT() {
    if(this.dataAuth) {
      return Promise.resolve(this.dataAuth);
    }

    return new Promise(resolve => {
      this.storage.get('token')
          .then(token => {
            this.storage.get('kodeSekolah')
                .then(kodeSekolah => {
                  this.storage.get('yayasan')
                      .then(yayasan => {
                        var data;

                        if(token !== null) {
                          data = {
                            exp: this.jwtHelper.isTokenExpired(token),
                            data: this.jwtHelper.decodeToken(token),
                            kodeSekolah: kodeSekolah,
                            yayasan: yayasan
                          }
                        } else {
                          data = {
                            exp: true
                          }
                        }
                        
                        this.dataAuth = data;
                        resolve(this.dataAuth);
                      });
                });
          });
    });
  }

  getCheckAuth() {
    if(this.dataAuth) {
      return Promise.resolve(this.dataAuth);
    }

    return new Promise(resolve => {
      this.storage.get('token')
          .then(val => {
            this.dataAuth = val;
            resolve(this.dataAuth);
          });
    });
  }

  getCheckPassword(password) {
    this.checkPassword = null;
    if(this.checkPassword) {
      return Promise.resolve(this.checkPassword);
    }

    return new Promise(resolve => {
      this.storage.get('token')
          .then(token => {
            var decodeToken = this.jwtHelper.decodeToken(token),
                username = decodeToken.data_user.username,
                url = this.ipAddress + "C_Change_Password/check?username="+ username +"&password="+ password;

            let headers = new Headers();
            headers.append('Content-Type', 'application/x-www-form-urlencoded');
            headers.append('Authorization', token);

            let options = new RequestOptions({headers: headers});

            this.http.get(url, options)
                .map(res => res.json())
                .subscribe(data => {
                  this.checkPassword = data;
                  resolve(this.checkPassword);
                });
          });
    });
  }

  postChangePassword(password) {
    this.changePassword = null;
    if(this.changePassword) {
      return Promise.resolve(this.changePassword);
    }

    return new Promise(resolve => {
      this.storage.get('token')
          .then(token => {
            var decodeToken = this.jwtHelper.decodeToken(token),
                username = decodeToken.data_user.username,
                url = this.ipAddress + "C_Change_Password/change";

            let headers = new Headers();
            headers.append('Content-Type', 'application/x-www-form-urlencoded');
            headers.append('Authorization', token);

            let options = new RequestOptions({headers: headers});
            var body = "username="+ username + "&password="+ password; 

            this.http.post(url, body ,options)
                .map(res => res.json())
                .subscribe(data => {
                  this.changePassword = data;
                  resolve(this.changePassword);
                });
          });
    });
  }

  getLogout() {
    // this.storage.remove('token');
    // this.storage.remove('dataUser');
    this.storage.set('token', null);
    this.storage.remove('dataUser');
    this.storage.remove('dataKelas');
    this.storage.remove('group');
    this.storage.remove('decodeToken');
    // this.storage.remove('ip');
    // this.storage.remove('idSekolah');
    this.storage.remove('kodeSekolah');
    this.storage.remove('yayasan');

    OneSignal.setAppId(APP_ID_ONESIGNAL);
    // OneSignal.deleteTag('idSekolah');
    OneSignal.deleteTag('kodeSekolah');
    OneSignal.deleteTag('yayasan');
    OneSignal.deleteTag('group');
    OneSignal.deleteTag('idUser');
    OneSignal.deleteTag('idKelas');
  }

}



// WEBPACK FOOTER //
// ./src/providers/auth-service.ts